import { useEffect, useState } from "react";
import { setOverrideModule, unsetOverrideModule } from "redux/reducers/overrideModulesReducer";
import store from "redux/store";
import { useAppSelector } from "../../../redux/hooks";
import { SearchInput } from "../../fields/base/TextField";
import { css } from "../../../../styled-system/css";
import { useHistory } from "react-router-dom";
import useOrgReduxState from "hooks/useOrgReduxState";
import { handleDefaultMarketplace, handleProfileOrMarketplaceChangeRedirects } from "utils/handleDefaultMarketplace";
import { changeOrg } from "utils/org";

interface Props {
  handleSearchQuery: (query: string) => void;
  defaultQueryValue?: string;
  pathname: string;
  resultModalSearchbar?: boolean;
}

const shortcuts = {
  "ad:": "/user/advertising/dashboard/ads/",
  "cat:": "/user/merchandising/category/",
  "acat:": "/user/advertising/dashboard/category/",
  "pp:": "/user/_pricing/plan/",
  "prd:": "/user/merchandising/product/",
  li: "/user/dsp/lineitems/",
  ord: "/user/dsp/orders/",
};

const SearchBar2 = ({ handleSearchQuery, defaultQueryValue = "", pathname, resultModalSearchbar = false }: Props) => {
  const { updateOrgReduxState } = useOrgReduxState();

  const setOrg = async (id: number | string | undefined) => {
    await changeOrg(id, true, updateOrgReduxState);
    await handleDefaultMarketplace();
    handleProfileOrMarketplaceChangeRedirects(history);
    window.location.reload();
  };

  const [query, setQuery] = useState(defaultQueryValue);

  const user = useAppSelector((state) => state.user);
  const history = useHistory();

  useEffect(() => {
    if (!resultModalSearchbar) {
      setQuery("");
    }
  }, [pathname, resultModalSearchbar]);

  return (
    <SearchInput
      aria-label={"Search"}
      placeholder="Search..."
      value={query}
      onChange={setQuery}
      onSubmit={(value) => {
        for (const [shortcut, path] of Object.entries(shortcuts)) {
          if (value.indexOf(shortcut) === 0) {
            const query = value.split(`${shortcut}`)[1];
            history.push(`${path}${query}`);
          }
        }

        if (value.indexOf("org:") === 0 && user.is_staff) {
          void setOrg(value.split("org:")[1]);
        } else if (value.indexOf("set-module:") === 0) {
          const module = value.split("set-module:")[1]!.trim();
          store.dispatch(setOverrideModule({ orgId: user.organization_id, module }));
          handleSearchQuery("");
          setQuery("");
        } else if (value.indexOf("unset-module:") === 0) {
          const module = value.split("set-module:")[1]!.trim();
          store.dispatch(unsetOverrideModule({ orgId: user.organization_id, module }));
          handleSearchQuery("");
          setQuery("");
        } else {
          handleSearchQuery(value);
        }
      }}
      className={css({ display: { lgDown: "none" }, flex: "0 1 400px" })}
    />
  );
};

export default SearchBar2;
